import { createTheme, responsiveFontSizes, } from '@mui/material/styles';
import { createBreakpoints } from '@mui/system';
import { green, red } from '@mui/material/colors';
import MuiButtonVariants from './MuiButtonVariants';
const breakpoints = createBreakpoints({});
const defaultTheme = createTheme({
    palette: {
        primary: {
            main: '#2196F3',
        },
        selection: {
            main: '#7986cb',
            light: '#939ed5',
            dark: '#545d8e',
            contrastText: '#ffffff',
        },
        grading: {
            faint: green[800],
            minor: '#AF9308',
            moderate: '#E18908',
            heavy: '#EF6C02',
            excessive: red[700],
        },
        action: {
            disabledBackgroundHover: 'rgba(0, 0, 0, 0.16) !important',
            disabledHoverOpacity: 0.16,
            focusVisibleOpacity: 0.30,
            disabledOpacity: 0.38,
            disabled: 'rgba(0, 0, 0, 0.38)',
        },
        overlay: {
            white: 'rgba(255, 255, 255, 0.5)',
        },
        trove: {
            orange: {
                main: '#FA7B34',
            },
            lightGrey: {
                main: '#EBEBE6',
            },
            darkGrey: {
                main: '#333235',
            },
            offWhite: {
                main: '#FAFAFA',
            },
        },
        modules: {
            itemInspection: '#FA7B34',
            itemIdentification: '#647C18',
            default: '#606163',
        },
        alert: {
            errorFill: '#FBEAEA',
            errorContent: '#541313',
        },
    },
    typography: {
        h1: {},
        h2: {},
        h3: {},
        h4: {},
        body1: {},
        body2: {},
        subtitle1: {},
        subtitle2: {},
        fontFamily: [
            'Roboto',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    },
    spacing: 16,
    components: {
        MuiButton: {
            defaultProps: {
                variant: 'contained',
            },
            variants: MuiButtonVariants
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    minHeight: 48,
                },
            },
        },
        MuiContainer: {
            styleOverrides: {
                root: {
                    // Removes default padding when screen size is small
                    [breakpoints.up('sm')]: {
                        paddingLeft: 0,
                        paddingRight: 0,
                        padding: '40px 0',
                        alignSelf: 'center',
                        margin: '0 48px',
                        width: 'calc(100% - 96px)',
                    },
                },
            },
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            desktop: 1024,
            lg: 1200,
            xl: 1536,
        },
        keys: ['xs', 'sm', 'md', 'desktop', 'lg', 'xl'],
    }
});
export default responsiveFontSizes(defaultTheme);
//# sourceMappingURL=default.js.map